(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-product-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.animated-grid-item');
  items.forEach((item, index) => {
    item.style.opacity = 0;
    item.style.transform = 'translateY(30px)';
    setTimeout(() => {
      item.style.transition = 'all 0.6s ease';
      item.style.opacity = 1;
      item.style.transform = 'translateY(0)';
    }, index * 150);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); this.trans = this.dataset.trans; }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headersub = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
      this.onScroll();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top || scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure(); this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(d => d.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    // Pre-warm dropdown GPU layers on first hover to eliminate first-open jank
    const navItems = document.querySelectorAll(
      'header-menu details summary, .header__inline-menu details summary'
    );
    navItems.forEach(summary => {
      summary.addEventListener('mouseenter', () => {
        const panel = summary.closest('details')?.querySelector('ul.list-menu');
        if (panel) panel.style.willChange = 'transform, opacity';
      }, { passive: true });
    });

    // Scroll-based sticky logic
    const header = document.querySelector('.section-header');
    const headerWrapper = document.querySelector('.header-wrapper');
    let headerIsAlwaysSticky = headerWrapper && (headerWrapper.dataset.stickyType === 'always' || headerWrapper.dataset.stickyType === 'reduce-logo-size');
    let headerBounds = {};
    let currentScrollTop = 0;
    const onScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (!header) return;
      if (!headerIsAlwaysSticky) {
        if (scrollTop > currentScrollTop && scrollTop > headerBounds.bottom || scrollTop > header.offsetHeight) {
          header.classList.add('not_sticky');
        } else if (scrollTop < currentScrollTop && scrollTop > headerBounds.bottom || scrollTop > header.offsetHeight) {
          header.classList.add('not_sticky');
        } else if (scrollTop <= headerBounds.top || scrollTop < header.offsetHeight) {
          header.classList.remove('not_sticky');
        }
      }
      currentScrollTop = scrollTop;
    };
    window.addEventListener('scroll', onScroll, false);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-redesign"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.trans = this.dataset.trans;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headersub = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.onScroll();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight ) {
      // if (scrollTop != 0) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight ) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top || scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);










  
  document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.section-header');
  const headerWrapper = document.querySelector('.header-wrapper');
  let headerIsAlwaysSticky = headerWrapper && headerWrapper.dataset.stickyType === 'always' || headerWrapper.dataset.stickyType === 'reduce-logo-size';
  let headerBounds = {};
  let currentScrollTop = 0;
  // let preventReveal = false;
  // let isScrolling;

  const onScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (!header) return;
    if (!headerIsAlwaysSticky) {
      if (scrollTop > currentScrollTop && scrollTop > headerBounds.bottom || scrollTop > header.offsetHeight) {
        header.classList.add('not_sticky');
      } else if (scrollTop < currentScrollTop && scrollTop > headerBounds.bottom || scrollTop > header.offsetHeight) {
        header.classList.add('not_sticky');
      } else if (scrollTop <= headerBounds.top || scrollTop < header.offsetHeight) {
        header.classList.remove('not_sticky');
      }
    } 
    currentScrollTop = scrollTop;
  };
  window.addEventListener('scroll', onScroll, false);
});


  } catch(e) { console.error(e); }
})();
})();
